import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import BasePlayerButton from "./BasePlayerButton";
const DownloadButton = ({ medias, onError, onFinished }) => {
    const [isDownloading, setIsDownloading] = useState(false);
    // A few considerations on this implementation:
    // - We're assuming as fallback that the media has mp4 extension, this is a acceptable
    //   simplification for the main use case.
    //
    // - A better approach could be downloading from the fetch stream, instead of load and
    //   download. This player is mostly used with short videos, so the loading step shouldn't
    //   take long, and the experience shouldn't be deeply affected.
    const downloadVideos = async () => {
        try {
            setIsDownloading(true);
            for (const media of medias) {
                const response = await fetch(media.src);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = media.downloadFileName ?? "video.mp4";
                link.click();
            }
            onFinished?.();
        }
        catch (error) {
            onError?.(error);
        }
        finally {
            setIsDownloading(false);
        }
    };
    const label = isDownloading ? "Baixando" : "Baixar";
    return _jsx(BasePlayerButton, { label: label, iconName: "download", onClick: downloadVideos, loading: isDownloading, disabled: isDownloading });
};
DownloadButton.displayName = "DownloadButton";
export default DownloadButton;
